<template>
    <div id="app" class="mainContainer">
        <div id="welcomeDiv" v-if="!allowSpeech">
            <div class="btnDiv" ref="btns" v-if="isReady">
                <div id="yesBtn" class="YNbtn" @click="startAva"></div>
                <div id="noBtn" class="YNbtn" @click="closeAva"></div>
            </div>
            <!--<div class="btnDiv" ref="btns" v-if="!isReady">
            Loading...
        </div>-->
        </div>
        <Ava v-if="allowSpeech" />
        <Dialog v-if="allowSpeech" />
    </div>
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    import Ava from "./components/Ava.vue";
    import Dialog from "./components/Dialog.vue";
    import { mapState, mapActions, mapGetters } from 'vuex';

    export default {
        name: 'App',
        directives: { focus },
        components: {
            Ava,
            Dialog
        },
        created() {
            this.$store.dispatch('loadAva'),
                this.$store.dispatch('preloadAnimations'),
                // start Ava bot conversation
                this.$store.dispatch('startConversation'),
                // get user icon from campus
                this.$store.dispatch('fetchUserData');
        },
        computed: {
            ...mapState({
                allowSpeech: state => state.allowSpeech,
                isReady: state => state.isReady,
                selectedDialogGroup: state => state.selectedDialogGroup
            })
        },
        methods: {
            ...mapActions({
                startAva: 'startAva',
                closeAva: 'closeAva'
            })
        }
    }
</script>
<style>

    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    body {
        /*background-image: url('assets/images/BG.jpg');
        background-repeat: no-repeat !important;
        background-position: center;*/
    }

    .mainContainer {
        height: 540px;
        width: 990px;
        margin: auto;
    }

    textarea, select, input, button {
        outline: none;
    }

    #welcomeDiv {
        width: 979px;
        height: 440px;
        background-image: url(~/ava/ava_welcome.png);
        position: relative;
    }

    .btnDiv {
        position: absolute;
        top: 229px;
        right: 84px;
        width: 365px;
        height: 105px;
        cursor: pointer;
    }

    .YNbtn {
        width: 159px;
        height: 89px;
        float: left;
        z-index: 100;
    }

    #yesBtn {
        background-image: url(~/ava/ava_yes_regular.png);
    }

        #yesBtn:hover {
            background-image: url(~/ava/ava_yes_hover.png);
        }

        #yesBtn:active {
            background-image: url(~/ava/ava_yes_click.png);
        }


    #noBtn {
        background-image: url(~/ava/ava_no_regular.png);
    }

        #noBtn:hover {
            background-image: url(~/ava/ava_no_hover.png);
        }

        #noBtn:active {
            background-image: url(~/ava/ava_no_click.png);
        }
</style>
